import pick from "lodash/pick";
import { getGraphURL } from "../serviceHelper";
import {
  IBusinessCardRequest,
  IBusinessCardResponse,
} from "../../pages/procedure/company-office/business-card/models/IBusinessCard";
import { StringHelper } from "../../helper";
import { Page } from "../../constants";
import { GraphRequestBaseService } from "../GraphRequestBase.service";

const fields = [
  "Title",
  "eName",
  "eCardName",
  "eCardTitle",
  "eCardEmail",
  "eCardAddress",
  "eCardSite",
  "eCardPhone",
  "eDescription",
  "eDepartment",
  "eUnit",
  "eComments",
  "eRequestType",
  "eRequestStatus",
  "eApprovalProcess",
];
const BASE_URL = getGraphURL(Page.businessCard);
class BusinessCardRequests extends GraphRequestBaseService {
  constructor(public baseURL: string, public fields: string[]) {
    super(baseURL, fields);
  }
  toRequest(body: any): IBusinessCardRequest {
    const request = pick(body, fields);
    if (body?.eApprovalProcess) {
      request["eApprovalProcess"] = JSON.stringify(body.eApprovalProcess);
    }
    return request as IBusinessCardRequest;
  }
  toResponse(response: any): IBusinessCardResponse {
    const fieldData = pick(response?.fields, fields);
    return {
      ...fieldData,
      id: response.id,
      eCreatedBy: `${response.createdBy.user.email}|${response.createdBy.user.displayName}`,
      createdDateTime: response.createdDateTime,
      eComments: StringHelper.parseJSON(response?.fields?.eComments, []),
      eApprovalProcess: StringHelper.parseJSON(
        response?.fields?.eApprovalProcess,
        []
      ),
    } as IBusinessCardResponse;
  }
}

export const businessCardApi = new BusinessCardRequests(BASE_URL, fields);
